import { LoadingSpinner, styled } from '@zeiss/beyond-online-react';

const LoadingState = styled.div`
  padding: var(--spacing-m) 0;
`;

/**
 *
 * This component is used to show a loading spinner in the autocomplete dropdown.
 * in combination with a workaround for the `AutoComplete` component.
 *
 *
 * NOTE: Beyond Online React Workaround
 * The current (v4.31.0) implementation of the `AutoComplete` component only
 * shows the loading state if the `loading` prop is set to true **and** there
 * is no text in the input field.
 */
export const AutoCompleteLoading = () => {
  return (
    <LoadingState>
      <LoadingSpinner size="xs" />
    </LoadingState>
  );
};
